exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.zdyFromItem input {\n  height: 2.5rem;\n  width: 8.2rem;\n}", ""]);

// exports
